export enum LoanProposalStatus_Enum {
  Processing = 1,
  Declined = 2,
  ProvisionalAcceptance = 3,
  Accepted = 4,
  ConditionallyAccepted = 5,
  FailedSendRules = 6,
  MoreInfo = 7,
  ManualProcessing = 8,
  Expired = 9,
}
